<template>
  <div class="main-body">
    <!-- 查询区域 -->
    <div class="search-box">
      <el-input v-model="query.company" placeholder="公司主体" style="width:200px" />
      <el-input v-model="query.company_code" placeholder="公司主体编号" style="width:200px" />
      <el-button type="primary" @click="getList">搜索</el-button>
    </div>

<!--
CREATE TABLE `sp_company` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `company` varchar(255) DEFAULT NULL,
  `company_code` varchar(50) DEFAULT NULL,
  PRIMARY KEY (`id`)
) ENGINE=InnoDB AUTO_INCREMENT=296 DEFAULT CHARSET=utf8 COMMENT='公司主体表';
-->

    <!-- 表格 -->
    <el-table :data="pageData.list" border height="70vh">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="company" label="公司主体" />
      <el-table-column prop="company_code" label="公司主体编号" />
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="pageChange"
      @current-change="pageChange"
      :current-page="pageData.page"
      :page-size="pageData.size"
      layout="total, prev, pager, next"
      :total="pageData.total"
      style="margin-top:15px;text-align:right"
    />

    <!-- 新增/编辑弹窗 -->
    <!--    <el-dialog :visible.sync="dialogVisible" title="用户信息">-->
    <!--      <el-form :model="form" label-width="80px">-->
    <!--        <el-form-item label="用户名">-->
    <!--          <el-input v-model="form.username" />-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="手机号">-->
    <!--          <el-input v-model="form.phone" />-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->
    <!--      <div slot="footer">-->
    <!--        <el-button @click="dialogVisible = false">取消</el-button>-->
    <!--        <el-button type="primary" @click="submit">确认</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
  </div>
</template>

<script>
import Http from './common/Http'
import Params from './common/Params'

export default {
  name: 'Company',
  data() {
    return {
      query: {
        company:"",
        company_code:"",
      },
      pageData:{
        list: [],
        total: 0,
        page: 1,
        size: 20,
      },
      dialogVisible: false,
      form: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // ====================== 获取列表 ======================
    getList() {
      const params = Params.ins()
        .where(this.query.company ? ['company', 'like', '%' + this.query.company + '%'] : null)
        .where(this.query.company_code ? ['company_code', '=', this.query.company_code] : null)
        .order('id desc')
        .page(this.pageData.page)
        .size(this.pageData.size)
        .list()

      Http.post('Company/index', params, res => {
        if(res.code===200){
          this.pageData = res.data
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    pageChange(page) {
      this.pageData.page = page
      this.getList()
    },

    // 新增
    handleAdd() {
      this.form = {}
      this.dialogVisible = true
    },

    // 编辑
    // async handleEdit(id) {
    //   const res = await api.detail(Params.ins().detail(id))
    //   if (res.code === 200) {
    //     this.form = res.data
    //     this.dialogVisible = true
    //   }
    // },
    //
    // // 提交保存
    // async submit() {
    //   const res = await api.save(Params.ins().save(this.form))
    //   if (res.code === 200) {
    //     this.$message.success('操作成功')
    //     this.dialogVisible = false
    //     this.getList()
    //   }
    // },
    //
    // // 删除
    // async handleDelete(id) {
    //   this.$confirm('确定删除？').then(async () => {
    //     const res = await api.delete(Params.ins().delete(id))
    //     if (res.code === 200) {
    //       this.$message.success('删除成功')
    //       this.getList()
    //     }
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
@import "./common.scss";
.main-body{
  padding: 15px;

  .search-box {
    margin-bottom: 15px;
    display: flex;
    gap: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/FinancialCenter/Company.vue